import { MobileCardDefinition } from '../services';
import { makeStyles, createStyles, ListItem, Typography, Theme } from '@material-ui/core';
import { FC } from 'react';
import { useLayoutNodeErrorCount } from '..';
import React from 'react';
import { TemplatedText, TemplatedTextProps } from './TemplatedText';
export interface TableOfContentsCardProps {
  path: string;
  index: number;
  definition: MobileCardDefinition;
  onCardSelected: (card: number) => void;
}

var useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    error: {
      color: theme.palette.error.main,
      position: 'absolute',
      right: theme.spacing(2)
    },
    tocCards: {
      padding: theme.spacing(0, 0, 2, 4),
      backgroundColor: theme.palette.grey[100]
    },
    sidebar: {
      position: 'absolute',
      top: 0,
      // left: theme.spacing(1),
      left: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center'
    },
    sidebarBar: {
      backgroundColor:
      theme.palette.grey[300],
      height: '100%',
      width: '2px'
    },
    sidebarNotch: {
      verticalAlign: 'middle',
      backgroundColor: theme.palette.grey[300],
      width: theme.spacing(1),
      height: '2px'
    }
  })
});

export const TableOfContentsCard: FC<TableOfContentsCardProps> = function(props) {
  const { definition, index, path } = props;
  const errors = useLayoutNodeErrorCount(path, definition);
  const classes = useStyles(props);

  return  (
    <ListItem
      button = { true }
      onClick = { () => props.onCardSelected(index) }>
      <div className = { classes.sidebar }>
        <div className = { classes.sidebarBar }></div>
        <div className = { classes.sidebarNotch }></div>
      </div>
      <Typography variant = { 'caption' }>
        { typeof definition.title === 'string'
          ? definition.title
          : <TemplatedText { ...definition.title as TemplatedTextProps }></TemplatedText>
        }
      </Typography>
      {
        errors > 0 && <Typography variant = { 'caption' } className = { classes.error }>
          { errors }
        </Typography>
      }
    </ListItem>
  )
};
